import { isTouchScreen } from '../../../styles'
import type { Tokens } from '../../../theming/types'
import type { TextBoxProps } from '..'

export default (config: {
  props: Pick<TextBoxProps, 'size'> & { isButton?: boolean }
  tokens: Tokens
}) => {
  const { tokens } = config
  const { props } = config

  const defaultButtonHeight =
    props.size === 'small'
      ? tokens.ctaSizeSm
      : `calc(${tokens.ctaSizeMd} - 2px)`
  const mobileButtonHeight = `calc(${tokens.ctaSizeLg} - 2px)`

  const textBoxButtonStyles = {
    minWidth: '40px',
    maxHeight: defaultButtonHeight,

    [isTouchScreen]: {
      maxHeight: mobileButtonHeight,
      '& > button': {
        minHeight: mobileButtonHeight,
      },
    },
  }

  return {
    default: {
      textBoxStartElement: {
        '& > button': {
          marginInlineEnd: props.isButton ? tokens.spacingGap100 : undefined,
          minHeight: defaultButtonHeight,
          height: props.size === 'small' ? tokens.ctaSizeSm : undefined,
          borderBottom: 'none',
          borderLeft: 'none',
          borderRadius: '1px 0 0 1px',
          borderTop: 'none',
        },
        ...textBoxButtonStyles,
      },

      textBoxEndElement: {
        '& > button': {
          minHeight: defaultButtonHeight,
          height: props.size === 'small' ? tokens.ctaSizeSm : undefined,
          borderBottom: 'none',
          borderRadius: '0 1px 1px 0',
          borderRight: 'none',
          borderTop: 'none',
        },
        ...textBoxButtonStyles,
      },

      help: {
        marginInlineStart: '8px',
      },
    },
  } as const
}
